import React from 'react';
import { Box } from '@mui/joy';

const ResponsiveDetailTable = ({ mobile, children }) => (
  <>
    <Box sx={{ display: { xs: mobile ? 'none' : 'block', md: 'block' }, overflowX: 'auto' }}>
      {children}
    </Box>
    {mobile && (
      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'column',
          gap: 1.5
        }}
      >
        {mobile}
      </Box>
    )}
  </>
);

export default ResponsiveDetailTable;
